import React from 'react'
import { withRouter } from "react-router-dom";
import { FormComponent } from '../../../components/form/DynamicForm';
import { Form, Validators } from '../../../components/form/DynamicFormTs';
import Http from '../../../Http';

class Salida extends FormComponent {

  componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'entrega/one', saveUrl: '', backUrl: '' },
      new Form([
        Form.Space(8),
        Form.FieldL('text', 'ead_folio', 'Folio de salida', '', [], 4, [], true),
        Form.Field('text', 'id', 'Entrega', '', [Validators.required], 4, [], [], [], false, true),
        // Form.Field('text', 'entrega', 'Entrega', '', [Validators.required], 4, [], [], [], false, true),
        Form.Field('date', 'fecha', 'Fecha de asignación', '', [Validators.required], 4, [], [], [], false, true),
        Form.Field('text', 'transportista', 'Transportista', '', [Validators.required], 4, [], [], [], false, true),
        Form.FieldL('date-hour', 'ead_fecha', 'Fecha y hora', new Date(), [Validators.required], 12, [], true),
      ], ['Cerrar', 'Guardar'], 'Registro de salidas')
    )
    // if (this.props.match.params.id)
    this.LoadPreds(this.props.id)
  }

  LoadPreds = async (predId = null) => {
    let id = predId ? predId : this.props.match.params.id;
    let Res = await Http.get(`entrega/one/${id}`);
    if (!Res.error) {
      if(!Res.data.ead_fecha) delete Res.data.ead_fecha
      this.setState({ FormData: Form.Patch(this.state.FormData, Res.data, true) })
    }
  }

  onSubmit = async (i, vals) => {
    this.setState({ loading: true })
    if (i === 2) {
      vals.id = this.props.id;
      try {
        let Res = await Http.post(`entrega/salida`, { entrega: vals });
        if (!Res.error) {
          this.setState({ sbMsg: 'Guardado', sbOpen: true, loading: false });
          this.props.onSave();
        } else {
          this.setState({ sbMsg: Res.errMsg, sbOpen: true, loading: false });
        }
      } catch (error) {
        console.log(error)
      }  
    } else {
      this.props.onSave();
    }    
  }

  render() {
    return (
      <div>
        <this.FormRender />
      </div>
    )
  }
}

export default withRouter(Salida)
